<template>
  <div class="emb-gadget-wrap">
    <emb-page-title
      v-if="categorySelected.Category_Image_1920x700"
      :heading="categorySelected.Category_Title"
      :subHeading="categorySelected.Category_Subtitle"
      :image="categorySelected.Category_Image_1920x700"
    ></emb-page-title>
    <emb-page-title
      v-else
      :heading="bannerImage.Title"
      :subHeading="bannerImage.Subtitle"
      :image="bannerImage.Banner_Image"
    ></emb-page-title>
    <div class="gadget-content section-gap">
      <v-container grid-list-xl py-0>
        <v-layout row wrap>
          <v-flex xs12 sm12 md4 lg3 xl3>
            <emb-sidebar-filters :sideSection="sideSection"></emb-sidebar-filters>
          </v-flex>
          <v-flex xs12 sm12 md8 lg9 xl9>
            <product-items :labels="mainLabel"></product-items>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>



<script>
import gettingRestClientObject from "../../services/utils/cms-helper";
import { mapGetters } from "vuex";

import ProductItems from "Components/Ecommerce/ProductItems";
import SidebarFilters from "Components/Ecommerce/SidebarFilters";

export default {
  components: {
    embSidebarFilters: SidebarFilters,
    ProductItems,
  },
  data() {
    return {
      category: "",
      subCategory: "",
      sideSection: "",
      bannerImage: "",
      mainLabel: "",
    };
  },
  computed: {
    ...mapGetters(["categorySelected", "selectedLocale"]),
  },
  created() {
    this.$store.dispatch("getProducts");
  },
  watch: {
    selectedLocale: function () {
      // this.$store.dispatch("getProducts");

      // if (this.$route.query.category == 0) {
      //   this.category = "";
      // } else {
      //   this.category = this.$route.query.category
      //     ? this.$route.query.category
      //     : "" || "";
      // }
      // if (this.$route.query.subcategory == 0) {
      //   this.subCategory = "";
      // } else {
      //   this.subCategory = this.$route.query.subcategory
      //     ? this.$route.query.subcategory
      //     : "" || "";
      // }
      this.category = this.$route.query.category
        ? this.$route.query.category
        : "" || "";
      this.subCategory = this.$route.query.subcategory
        ? this.$route.query.subcategory
        : "" || "";
      // this.$store.dispatch("getProducts");
      this.getPageData();
    },
    $route() {
      // if (this.$route.query.category == 0) {
      //   this.category = "";
      // } else {
      //   this.category = this.$route.query.category
      //     ? this.$route.query.category
      //     : "" || "";
      // }
      // if (this.$route.query.subcategory == 0) {
      //   this.subCategory = "";
      // } else {
      //   this.subCategory = this.$route.query.subcategory
      //     ? this.$route.query.subcategory
      //     : "" || "";
      // }
      this.category = this.$route.query.category
        ? this.$route.query.category
        : "" || "";
      this.subCategory = this.$route.query.subcategory
        ? this.$route.query.subcategory
        : "" || "";
      const category = {
        category: this.category,
        subCategory: this.subCategory,
      };
      this.$store.dispatch("filterProducts", category);
    },
  },
  mounted() {
    // if (this.$route.query.category == 0) {
    //   this.category = "";
    // } else {
    //   this.category = this.$route.query.category
    //     ? this.$route.query.category
    //     : "" || "";
    // }
    // if (this.$route.query.subcategory == 0) {
    //   this.subCategory = "";
    // } else {
    //   this.subCategory = this.$route.query.subcategory
    //     ? this.$route.query.subcategory
    //     : "" || "";
    // }
    this.category = this.$route.query.category
      ? this.$route.query.category
      : "" || "";
    this.subCategory = this.$route.query.subcategory
      ? this.$route.query.subcategory
      : "" || "";
    const category = {
      category: this.category,
      subCategory: this.subCategory,
    };
    this.$store.dispatch("filterProducts", category);

    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  methods: {
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "19 Product Details/19 Product Details/19 Product Details.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var sideArea = self.cmsRequestFunctions.pluck(
              "Sidebar_Section",
              res.area_List
            );
            self.sideSection = self.cmsRequestFunctions.getAllMapData(
              sideArea[0].component
            );
            var Banner_Section = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );
            self.bannerImage = self.cmsRequestFunctions.getAllMapData(
              Banner_Section[0].component
            );
            var Main_Content = self.cmsRequestFunctions.pluck(
              "Main_Content",
              res.area_List
            );
            self.mainLabel = self.cmsRequestFunctions.getAllMapData(
              Main_Content[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>